import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBxSortUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.33337 5.99984H13.3334V7.33317H7.33337V5.99984ZM7.33337 8.6665H12V9.99984H7.33337V8.6665ZM7.33337 3.33317H14.6667V4.6665H7.33337V3.33317ZM7.33337 11.3332H10.6667V12.6665H7.33337V11.3332ZM3.33337 13.3332H4.66671V5.33317H6.66671L4.00004 2.6665L1.33337 5.33317H3.33337V13.3332Z",
		fill: "currentColor"
	})
});
export default SvgBxSortUp;
